const SCHEDULER_PATH = "/scheduler";

/**
 * First screen after login: Scheduler when the user can open it,
 * otherwise the first allowed route that is not the root redirect.
 */
export function getPostLoginPath(userRoles, routes) {
  const roles = Array.isArray(userRoles) ? userRoles : [];
  const allowed = (routes || []).filter((route) =>
    route?.allowedUserTypes?.some((role) => roles.includes(role))
  );

  if (allowed.some((route) => route.path === SCHEDULER_PATH)) {
    return SCHEDULER_PATH;
  }

  const fallback = allowed.find((route) => route.path && route.path !== "/");
  return fallback?.path ?? SCHEDULER_PATH;
}
